import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-offline-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './offline-page.component.html',
  styleUrls: ['./offline-page.component.scss']
})
export class OfflinePageComponent implements OnInit, OnDestroy {
  isOnline = true;
  showPage = false;
  retrying = false;
  private onlineHandler = () => this.onOnline();
  private offlineHandler = () => this.onOffline();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) return;

    this.isOnline = navigator.onLine;
    this.showPage = !this.isOnline;

    window.addEventListener('online', this.onlineHandler);
    window.addEventListener('offline', this.offlineHandler);
  }

  ngOnDestroy() {
    if (!isPlatformBrowser(this.platformId)) return;
    window.removeEventListener('online', this.onlineHandler);
    window.removeEventListener('offline', this.offlineHandler);
  }

  private onOnline() {
    this.isOnline = true;
    // small delay so the user sees the "back online" state
    setTimeout(() => { this.showPage = false; }, 1200);
  }

  private onOffline() {
    this.isOnline = false;
    this.showPage = true;
  }

  retry() {
    if (this.retrying) return;
    this.retrying = true;

    // Use multiple checks to determine connectivity
    if (!navigator.onLine) {
      this.retrying = false;
      this.isOnline = false;
      return;
    }

    // navigator.onLine is true but we might have no real internet — try a lightweight fetch
    fetch('https://www.google.com/favicon.ico', { method: 'HEAD', mode: 'no-cors', cache: 'no-store' })
      .then(() => {
        this.isOnline = true;
        setTimeout(() => { this.showPage = false; this.retrying = false; }, 600);
      })
      .catch(() => {
        this.retrying = false;
        this.isOnline = false;
      });
  }
}
